import PageWrapper from "../../common/components/PageWrapper";
import UserStats from "../components/UserStats";
import CommunityStats from "../components/CommunityStats";
import ChatRankingBoard from "../components/ChatRankingBoard";

export default function MainContainer() {
  return (
    <PageWrapper isColumnFlex={false}>
      <div className="flex w-2/3 flex-shrink-0 flex-col gap-1 overflow-y-auto">
        <UserStats />
        <CommunityStats />
      </div>
      <ChatRankingBoard />
    </PageWrapper>
  );
}
